import type {ProductBox} from './ProductBox';
import {store as preconfigStore} from '../PreconfigStore';
import {proxy} from 'valtio';
import type {DeepReadonly} from '@/lib/typings/readonly';
import type {ProductWidget} from '@/lib/TypesOpenApi';
import {stepsMap} from '@/app/signup/routing/StepsRouting';

export type PhoneBox = ProductBox<ProductWidget>;

const phoneData = stepsMap['PHONE'].store;

// if add any new field, add the new field to the below reset function also
export const phone = proxy<PhoneBox>({
  _product: undefined,

  // For RESI, allow only if phone was preselected
  get selected() {
    const buyflowType = phoneData.content?.buyflowState.buyflowType;

    if (buyflowType !== 'SMB' && !preconfigStore['PHONE_PRODUCT']) {
      return undefined;
    }

    return this._product;
  },

  get productId() {
    return this.selected?.productId;
  },

  get price() {
    return this.selected?.productCost?.units || 0;
  },

  get name() {
    return this.selected?.productName || '';
  },

  get isActualProduct() {
    return this.selected?.isActualProduct;
  },
});

export const resetPhone = () => {
  phone._product = undefined;
};

export const setPhone = (product: DeepReadonly<ProductWidget>) =>
  (phone._product = product as ProductWidget);
